import styled, { keyframes } from 'styled-components';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const fadeRight = keyframes`
  from { opacity: 0; transform: translateX(20px); }
  to { opacity: 1; transform: translateX(0); }
`;

export const PageHero = styled.div`
  min-height: 52vh;
  background: #03045e;
  display: flex;
  align-items: center;
  padding-top: 72px;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 3px;
    background: #00b4d8;
  }

  @media (max-width: 768px) { min-height: 45vh; }
`;

export const PageHeroInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 3rem 4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 4rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    padding: 2rem;
    gap: 2rem;
  }

  .left {
    animation: ${fadeUp} 0.8s ease-out;

    span {
      display: inline-flex;
      align-items: center;
      gap: 0.8rem;
      font-size: 0.7rem;
      font-weight: 800;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #00b4d8;
      margin-bottom: 1.2rem;

      &::before {
        content: '';
        display: inline-block;
        width: 24px;
        height: 2px;
        background: #00b4d8;
      }
    }

    h1 {
      font-size: clamp(2.8rem, 5vw, 5rem);
      font-weight: 900;
      color: #ffffff;
      letter-spacing: -4px;
      line-height: 1;
      margin-bottom: 1.5rem;
    }

    p {
      color: rgba(255,255,255,0.45);
      font-size: 1rem;
      font-weight: 400;
      max-width: 420px;
      line-height: 1.7;
    }
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    animation: ${fadeRight} 0.9s ease-out;

    @media (max-width: 900px) { display: none; }

    .data-title {
      font-size: clamp(8rem, 14vw, 13rem);
      font-weight: 900;
      color: rgba(255,255,255,0.04);
      letter-spacing: -8px;
      text-transform: uppercase;
      line-height: 1;
      text-align: right;
      user-select: none;
    }
  }
`;

export const PageWrap = styled.div`
  background: #f8faff;
  padding: 5rem 4rem;

  @media (max-width: 768px) { padding: 3rem 1.5rem; }
`;

export const PageInner = styled.div`
  max-width: ${p => p.wide ? '1200px' : '900px'};
  margin: 0 auto;
  overflow: hidden;
`;
